import translation from './translation.json';
import header from './header.json';

const resources = {
    translation,
    header,
};

export default resources;
